import React from "react";
import styles from "./index.module.scss";

const HeaderComponent = () => (
  <div className={styles.header}>History of notifications for active users</div>
);

export default HeaderComponent;
